import _ from 'lodash';
import qs from 'qs';
import request from '../request';
import { API } from '../../../global-constants';

const getAll = () =>
  request({
    baseURL: API.BASE_URL,
    url: API.PRODUCT_SUPPLIER,
    method: 'GET',
  });

const searchByName = searchText =>
  request({
    baseURL: API.BASE_URL,
    url: API.PRODUCT_SUPPLIER,
    method: 'GET',
    params: {
      filter: [
        searchText && {
          type: 'like',
          field: 'description',
          value: `%${searchText}%`,
        },
      ].filter(o => o),
    },
    paramsSerializer: params => qs.stringify(params),
  });

const getOptions = (inputValue, callback) => {
  searchByName(inputValue).then(results =>
    callback(
      _.get(results, 'data._embedded.product_supplier', []).map(supplier => ({
        value: supplier.id,
        label: supplier.description,
      })),
    ),
  );
  // eslint-disable-next-line no-useless-return
  return;
};

const create = content =>
  request({
    baseURL: API.BASE_URL,
    url: API.PRODUCT_SUPPLIER,
    method: 'POST',
    data: content,
  });

const update = content =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.PRODUCT_SUPPLIER}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const remove = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.PRODUCT_SUPPLIER}/${id}`,
    method: 'DELETE',
  });

const ProductSupplierService = {
  create,
  update,
  remove,
  getAll,
  getOptions,
};

export default ProductSupplierService;
